import React, { useEffect, useState } from "react";

/**
 * PageOpener — initial page-load effect: a kraft-paper curtain
 * slides up and reveals the site. Runs once per session.
 */
export default function PageOpener() {
  const [stage, setStage] = useState("in"); // in → fade → gone

  useEffect(() => {
    if (sessionStorage.getItem("gb_opener_seen")) {
      setStage("gone");
      return;
    }
    sessionStorage.setItem("gb_opener_seen", "1");
    const t1 = setTimeout(() => setStage("fade"), 950);
    const t2 = setTimeout(() => setStage("gone"), 1700);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (stage === "gone") return null;

  return (
    <div
      aria-hidden="true"
      className={`fixed inset-0 z-[100] pointer-events-none flex items-center justify-center overflow-hidden ${
        stage === "fade" ? "opener-fade" : ""
      }`}
    >
      <div className="opener-panel absolute inset-0 bg-[#2C221E]" />
      <div className="opener-noise absolute inset-0 noise opacity-[0.08]" />
      <div className="relative opener-mark text-[#FBF8F3] text-center">
        <p className="font-mono-brand text-[10px] tracking-[0.4em] text-[#C29B78] mb-3">
          ● A HELYI KÖRFORGÁS
        </p>
        <p className="font-mono-brand font-black text-2xl sm:text-4xl tracking-[0.22em]">
          GROWBAG
        </p>
        <p className="font-mono-brand text-[10px] tracking-[0.4em] text-[#8C8075] mt-3">
          XVII · BUDAPEST
        </p>
      </div>
    </div>
  );
}
